import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["accessibilityLabel", "id", "size", "testID", "UNSAFE_svgProps"];
import React from 'react';
import Surface from '@bubble-ui/primitive-surface';
import Shape from '@bubble-ui/primitive-shape';
import Defs from '@bubble-ui/primitive-defs';
import LinearGradient from '@bubble-ui/primitive-linear-gradient';
import Stop from '@bubble-ui/primitive-stop';
import RadialGradient from '@bubble-ui/primitive-radial-gradient';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
var ColoredIllustrationPrefilledDetails = _ref => {
  var {
      accessibilityLabel,
      id,
      size = 100,
      testID,
      UNSAFE_svgProps
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropsSpreadingDeprecationWarning({
    componentName: 'ColoredIllustrationPrefilledDetails',
    props,
    useInstead: 'UNSAFE_svgProps',
    removalDate: 'v7.0.0'
  });
  return /*#__PURE__*/React.createElement(Surface, _extends({
    id: id
  }, testID ? {
    testID
  } : {}, UNSAFE_svgProps, {
    accessibilityLabel: accessibilityLabel,
    fill: "none",
    viewBox: "0 0 100 100",
    width: size,
    height: size
  }, props), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint0_radial_21134_70014)",
    fillRule: "evenodd",
    d: "M71.72 94.65 70.5 83.81c-.69-6.2-5.59-11.09-11.79-11.79L47.87 70.8c-.37-.04-.37-.59 0-.63l10.84-1.22c6.2-.69 11.09-5.59 11.79-11.79l1.22-10.84c.04-.37.59-.37.63 0l1.22 10.84c.69 6.2 5.59 11.09 11.79 11.79l10.84 1.22c.37.04.37.58 0 .63l-10.84 1.22c-6.2.69-11.09 5.59-11.79 11.79l-1.22 10.84c-.05.38-.59.38-.63 0Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint1_radial_21134_70014)",
    fillRule: "evenodd",
    d: "m26.51 49.91-1.16-10.38a12.8 12.8 0 0 0-11.29-11.29L3.67 27.08c-.36-.04-.36-.56 0-.6l10.38-1.16a12.8 12.8 0 0 0 11.29-11.29L26.5 3.65c.04-.36.56-.36.6 0l1.16 10.38a12.8 12.8 0 0 0 11.29 11.29l10.38 1.16c.36.04.36.56 0 .6l-10.38 1.16a12.8 12.8 0 0 0-11.29 11.29L27.1 49.91c-.03.36-.55.36-.59 0Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint2_linear_21134_70014)",
    fillRule: "evenodd",
    d: "M70.9 7.37 84.07 17.5l-61.2 75.73s-3.15 3.59-9.32-1.02c-5.78-4.32-4.05-8.88-4.05-8.88L70.9 7.37Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint3_linear_21134_70014)",
    fillRule: "evenodd",
    d: "M80.37 8.99c-3.54-2.91-7.79-3.61-9.55-1.6h-.01l-.04.05v.01s-6.3 7.84-6.28 7.84c2.45 4.44 6.68 8.55 13.31 9.91 0-.01 5.83-7.08 5.83-7.08l.06-.06c1.73-2.08.25-6.14-3.32-9.07Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint4_linear_21134_70014)",
    fillRule: "evenodd",
    d: "M80.37 8.99c-3.54-2.91-7.79-3.61-9.55-1.6h-.01l-.04.05v.01c-1.11 3.2 9.29 11.43 12.87 10.67l.06-.06c1.72-2.08.24-6.14-3.33-9.07Z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(RadialGradient, {
    id: "paint0_radial_21134_70014",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(72.03 70.493) scale(24.4412)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: 0.32,
    stopColor: "#F4DC03"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.623,
    stopColor: "#F4DA05"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.787,
    stopColor: "#F3D20B"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.918,
    stopColor: "#F1C415"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#EFB71F"
  })), /*#__PURE__*/React.createElement(RadialGradient, {
    id: "paint1_radial_21134_70014",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(26.808 26.777) scale(23.4031)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: 0.32,
    stopColor: "#F4DC03"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.623,
    stopColor: "#F4DA05"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.787,
    stopColor: "#F3D20B"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.918,
    stopColor: "#F1C415"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#EFB71F"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint2_linear_21134_70014",
    x1: 29.915,
    x2: 68.844,
    y1: 38.436,
    y2: 72.318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: 0.336,
    stopColor: "#3AE8B9"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.558,
    stopColor: "#627CE9"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint3_linear_21134_70014",
    x1: 84.36,
    x2: 68.476,
    y1: 22.304,
    y2: 10.268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: 0.159,
    stopColor: "#5B71F3"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#5DA7F4"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint4_linear_21134_70014",
    x1: 69.513,
    x2: 89.249,
    y1: 11.144,
    y2: 13.466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#5DA7F4"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.332,
    stopColor: "#5B7AF3"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.391,
    stopColor: "#5B71F3"
  }))));
};
ColoredIllustrationPrefilledDetails.displayName = 'ColoredIllustrationPrefilledDetails';
export default withProvisionalOverrideFromContext(ColoredIllustrationPrefilledDetails);
//# sourceMappingURL=index.js.map